// extracted by mini-css-extract-plugin
export var icon = "_bk-3";
export var subtitle = "_bk-2";
export var title = "_bk-1";
export var value = "_bk-0";